"use strict";

exports.__esModule = true;
exports.MorphTwoWay = void 0;

var _basic = require("./basic.js");

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _defaults(subClass, superClass); }

/**
 * Morph animation from point A to B and then from B to A after mouse enter.
 */
var MorphTwoWay = /*#__PURE__*/function (_Basic) {
  _inheritsLoose(MorphTwoWay, _Basic);

  function MorphTwoWay() {
    return _Basic.apply(this, arguments) || this;
  }

  var _proto = MorphTwoWay.prototype;

  _proto.connectedCallback = function connectedCallback() {
    _Basic.prototype.connectedCallback.call(this);

    this.target.addEventListener('mouseenter', this.enterBound);
  };

  _proto.disconnectedCallback = function disconnectedCallback() {
    this.target.removeEventListener('mouseenter', this.enterBound);
    this.setDirection(1);

    _Basic.prototype.disconnectedCallback.call(this);
  };

  _proto.enter = function enter() {
    this.setDirection(1);
    this.play();
  };

  _proto.complete = function complete() {
    this.setDirection(-1);
    this.play();
  };

  return MorphTwoWay;
}(_basic.Basic);

exports.MorphTwoWay = MorphTwoWay;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hbmltYXRpb25zL21vcnBoLXR3by13YXkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQTs7Ozs7O0FBRUE7OztJQUdhLFc7Ozs7Ozs7OztTQUNULGlCLEdBQUEsNkJBQWlCO0FBQ2IscUJBQU0saUJBQU47O0FBRUEsU0FBSyxNQUFMLENBQVksZ0JBQVosQ0FBNkIsWUFBN0IsRUFBMkMsS0FBSyxVQUFoRDtBQUNILEc7O1NBRUQsb0IsR0FBQSxnQ0FBb0I7QUFDaEIsU0FBSyxNQUFMLENBQVksbUJBQVosQ0FBZ0MsWUFBaEMsRUFBOEMsS0FBSyxVQUFuRDtBQUVBLFNBQUssWUFBTCxDQUFrQixDQUFsQjs7QUFFQSxxQkFBTSxvQkFBTjtBQUNILEc7O1NBRUQsSyxHQUFBLGlCQUFLO0FBQ0QsU0FBSyxZQUFMLENBQWtCLENBQWxCO0FBQ0EsU0FBSyxJQUFMO0FBQ0gsRzs7U0FFRCxRLEdBQUEsb0JBQVE7QUFDSixTQUFLLFlBQUwsQ0FBa0IsQ0FBQyxDQUFuQjtBQUNBLFNBQUssSUFBTDtBQUNILEc7OztFQXZCNEIsWSIsInNvdXJjZVJvb3QiOiIifQ==